import type { ClientEvent, InstallerFrom } from '@lyrmo/shared';
import { createContext, useContext } from 'react';

/** Notes something the writer did; nothing at all where no tracking is provided. */
export const TrackingContext = createContext<(event: ClientEvent) => void>(() => undefined);

/** How to note something the writer did, for Lyrmo's own insights. */
export const useTrack = (): ((event: ClientEvent) => void) => useContext(TrackingContext);

/** How the writer came to the page on screen: arriving on it, or from another page. */
export const PageFromContext = createContext<InstallerFrom>('arrival');

/** How the writer came to the page on screen. */
export const usePageFrom = (): InstallerFrom => useContext(PageFromContext);
